<template>
  <div class="">
    <div class="commonfooter">
      <div class="cont">
        <div class="item">
          <div class="title">快速链接</div>
          <div class="sub-cont">
            <div class="sub-item">
              <div class="sub-link"><a href="/introduction">产品介绍</a></div>
              <div class="sub-link">
                <a
                  @click="
                    GetCode(
                      $config.Cydt.systemCode,
                      $config.Cydt.pageUrl + '/macrographydata'
                    )
                  "
                  >宏观数据</a
                >
              </div>
              <div class="sub-link">
                <a
                  @click="
                    GetCode(
                      $config.Cydt.systemCode,
                      $config.Cydt.pageUrl + '/datamap'
                    )
                  "
                  >数据地图</a
                >
              </div>
              <div class="sub-link">
                <a
                  @click="
                    GetCode(
                      $config.Cydt.systemCode,
                      $config.Cydt.pageUrl + '/heatmap'
                    )
                  "
                  >产业热力图</a
                >
              </div>
              <div class="sub-link">
                <a
                  @click="
                    GetCode(
                      $config.Yqk.systemCode,
                      $config.Yqk.pageUrl + '/gbaparkstore'
                    )
                  "
                  >大湾区园区库</a
                >
              </div>
            </div>
            <div class="sub-item">
              <div class="sub-link">
                <a
                  @click="
                    GetCode(
                      $config.Dp.systemCode,
                      $config.Dp.pageUrl + '/parkbigscreen'
                    )
                  "
                  >园区大屏</a
                >
              </div>
              <div class="sub-link">土地信息</div>
              <div class="sub-link">政策信息</div>
              <div class="sub-link">展会资讯</div>
              <div class="sub-link">活动资讯</div>
            </div>
          </div>
        </div>
        <div class="item">
          <!-- <div class="title">数据来源</div>
                <div class="sub-cont">
                    <div class="sub-item">
                        <div class="sub-link">全国企业信用信息公示系统</div>
                        <div class="sub-link">中国裁判文书网</div>
                        <div class="sub-link">中国执行信息公开网</div>
                        <div class="sub-link">国家知识产权局</div>
                        <div class="sub-link">商标局</div>
                        <div class="sub-link">版权局</div>
                    </div>
                </div> -->
        </div>
        <div class="item">
          <!-- <div class="title">友情链接</div>
                <div class="sub-cont">
                    <div class="sub-item">
                        <div class="sub-link">站长之家</div>
                        <div class="sub-link">新网</div>
                        <div class="sub-link">大街网</div>
                    </div>
                </div> -->
        </div>
        <div class="item">
          <div class="title-logo"></div>
          <div class="sub-cont">
            <div class="sub-item">
              <div class="sub-link"><i></i></div>
              <div class="sub-link"><i></i>18826578984</div>
              <div class="sub-link">
                <i></i
                ><el-link href="https://www.hezongshuju.com" target="_blank"
                  >https://www.hezongshuju.com</el-link
                >
              </div>
              <div class="sub-link"><i></i>meiying.shi@hezongshuju.com</div>
              <div class="sub-code"></div>
            </div>
          </div>
        </div>
        <div class="record">
          Copyright © 2020 深圳合纵数据科技有限公司&nbsp;&nbsp;<a
            target="_blank"
            href="https://beian.miit.gov.cn"
            >粤ICP备19126409号-5</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRequestCode } from "../api/api.js";
export default {
  name: "",
  data() {
    return {};
  },
  components: {},
  methods: {
    GetCode(SysId, url) {
      let params = {
        SystemId: SysId
      };
      var parkToken = localStorage.getItem("parkToken");
      if (!parkToken) {
        //直接跳转http
        window.location.href = url;
      } else {
        getRequestCode(params)
          .then(function(response) {
            let res = response.data;
            if (res.code == 1) {
              //console.log('');
              window.location.href = url + "?code=" + res.data;
            } else {
              // if (res.code == -10) {
              //   this.commonTipsError(res.result);
              // } else {
              this.commonTipsError("授权失败");
              //}
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    }
  }
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/common/commonfooter.vue